import React from 'react';

const Dots = () => {
  return (
    <div className="dots">
      <div className="dots__dot"></div>
      <div className="dots__dot"></div>
      <div className="dots__dot"></div>
      <div className="dots__dot"></div>
      <div className="dots__dot"></div>
    </div>
  );
};

export default Dots;
